import { Component, Input } from '@angular/core';
import { AlertService } from '../../services/Alert/alert.service';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)', opacity: 0 }),
        animate('400ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('400ms ease-in', style({ transform: 'translateX(-100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class AlertComponent {
  alerts: any[] = [];

  constructor(private alertService: AlertService) {
    this.alertService.alerts$.subscribe(alerts => {
      this.alerts = alerts;
    });
  }

  remove(id: number) {
    this.alertService.removeAlert(id);
  }

  isLoginRequiredAlert(message: string): boolean {
    return message.includes('continue as a guest') && message.includes('logged in');
  }

  isAddedToCartAlert(message: string): boolean {
    return message.includes('Added to cart');
  }

  isUpdatedCartAlert(message: string): boolean {
    return message.includes('Quantity updated');
  }
  
  enableGuestMode() {
    sessionStorage.setItem('guestMode', 'true');
    localStorage.removeItem('romaPizza_token_to_verify');
    window.location.reload();
  }

  goToCart() {
    window.location.href = '/cart';
  }

  getToastIcon(type: string): string {
    const icons: { [key: string]: string } = {
      success: '✓',
      warning: '!',
      danger: '✕',
      info: 'i'
    };
    return icons[type] || '●';
  }

  getToastTitle(type: string): string {
    const titles: { [key: string]: string } = {
      success: 'Success!',
      warning: 'Warning',
      danger: 'Error',
      info: 'Information'
    };
    return titles[type] || 'Notification';
  }
}